import React from "react";
import AudioUploader from "./components/AudioUploader";

import { TbAlertTriangleFilled } from "react-icons/tb";

import "./App.css";

function App() {
  return (
    <div className="App">
      <main>
        <AudioUploader />
      </main>
      <div className="celAlert">
        <TbAlertTriangleFilled className="iconAlert" />
        <h2>Essa é uma aplicação apenas para dispositivos desktop.</h2>
      </div>
      <footer className="creditos">
        <p>
          Developed and created by{" "}
          <strong>
            <a href="https://e2tcode.com" target="_blank" rel="noreferrer">
              E2T Code
            </a>
          </strong>
        </p>
      </footer>
    </div>
  );
}

export default App;
